module.exports = __webpack_public_path__ + "img/flashlight.1bb099d1.svg";